module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<fieldset>\n    <legend class="collapsible collapsed" data-toggle="collapse" data-target=".product-properties-accordion">Product\n    </legend>\n    <div class="product-properties-accordion collapse collapse-target">\n        <div>\n            <div class="product-region">\n                <div id="input-region">\n                    <input type="text" id="dynamic-product-id-input" class="full-width" value= "' +
((__t = (productID)) == null ? '' : __t) +
'" autocomplete="off" placeholder="Type your Product ID here&#8230;">\n                    <button id="search-button" class= "search-button">\n                    ';
 if (hasInput && isValidInput) { ;
__p += '\n                    <span id="correct-product-id" class="glyphicon glyphicon-ok"></span>\n                    ';
 } ;
__p += '\n                    ';
 if (hasInput && !isValidInput) { ;
__p += '\n                    <span id="incorrect-product-id" class="glyphicon glyphicon-remove"></span>\n                    ';
 } ;
__p += '\n                </div>\n                <div class="toggle-subwidgets-region"></div>\n            </div>\n        </div>\n    </div>\n</fieldset>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/dynamicProductWidget/ProductPropertiesView.tpl
// module id = 2087
// module chunks = 0